import { importLibrary, LibraryMap, setOptions } from "@googlemaps/js-api-loader";
import i18n from "i18next";
import { getGoogleMapsBrowserApiKey } from "src/config/appConfig.ts";

/** The map ID of Aavo's maps, which advanced markers require. */
export const GOOGLE_MAPS_MAP_ID = "DEMO_MAP_ID";

/** The browser settings of Aavo's Google Maps, shared with Custom Apps that use Google Maps. */
export function getGoogleMapsBrowserConfiguration() {
	return {
		apiKey: getGoogleMapsBrowserApiKey(),
		mapId: GOOGLE_MAPS_MAP_ID,
		language: i18n.language,
		region: "FI",
	};
}

let optionsSet = false;

export async function loadGoogleMapsLibrary<TLibraryName extends keyof LibraryMap>(
	libraryName: TLibraryName,
): Promise<LibraryMap[TLibraryName]> {
	if (!optionsSet) {
		const { apiKey, language, region } = getGoogleMapsBrowserConfiguration();
		setOptions({ key: apiKey, v: "weekly", language, region });
		optionsSet = true;
	}

	return await importLibrary(libraryName);
}
